<script>
    import { doc } from "../util/stores.js"

    //PLOT PAGE MODULE COMPONENTS:
    import Plot_card from "../plot-modules/plot_card.svelte"
    import Tension_Curve from "../plot-modules/tension_curve.svelte"

    //CHARACTER PAGE MODULE COMPONENTS:
    import Char_card from "../char-modules/char_card.svelte"
    import Socionics from "../char-modules/socionics.svelte"

    export var width=0, track_index, modules, remove_callback, removable=true, page;

    function UpdateDocModuleInfo(module_index, prop, val){
        modules[module_index][prop] = val;
        console.log("Changed module :"+modules[module_index]['type']+": "+prop+" to " + val)
    }

    function fetchDocValuesFor(module_type, i){
        var vals = {}
        var props = []
        var module = $doc['boards'][page][track_index]['modules'][i]
        if(module_type == 'char card'){
            props = ['color', 'name', 'role', 'faction', 'description']
        }else if(module_type == 'plot card'){
            props = ['genre', 'chars', 'time', 'promise', 'resolve', 'progress']
        }else if(module_type == 'socionics'){
            props = ['MBTI', 'Enneagram']
        }

        props.forEach(prop => {
            vals[prop] = module[prop] ? module[prop] : ''
        })

        return vals
    }    
</script>


<div class="track_scroll_wrapper" style="width: {width == 0 ? '50%' : width};"> 
    <div class="track_flex">
        <div class="header">
            <span>{page} track {track_index+1}</span>
            {#if removable}
                <button class="remove" on:click={() => {remove_callback(page, track_index)}}></button>
            {/if}
        </div>
        {#each modules as mod,i}
            {#if mod['type'] == 'char card'}
            <!--Character board cards-->
                <Char_card mod_index={i} updateCallback={UpdateDocModuleInfo} values={fetchDocValuesFor(mod['type'], i)}></Char_card>
            {:else if mod['type'] == 'socionics'}
                <Socionics mod_index={i} updateCallback={UpdateDocModuleInfo} values={fetchDocValuesFor(mod['type'], i)}></Socionics>

            <!--Plot board cards-->
            {:else if mod['type'] == 'plot card'} 
                <Plot_card mod_index={i} updateCallback={UpdateDocModuleInfo} values={fetchDocValuesFor(mod['type'], i)}></Plot_card>
            {:else if mod['type'] == 'tension curve'}
                <Tension_Curve mod_index={i} updateCallback={UpdateDocModuleInfo} values={fetchDocValuesFor(mod['type'], i)}></Tension_Curve>
            {/if}
        {/each}
    </div>
</div>


<style lang="scss">
    @use "styles/global.scss";

    .track_scroll_wrapper{
        height: 100%;

        overflow: hidden;
        overflow-y: scroll;
        flex-shrink:0;

        @include custom_scrollbar;

        .track_flex{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;

            .header{
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                align-items: center;
                flex-shrink: 0;

                width: 95%;
                height: 48px;
                border-radius: 0 0 24px 24px;

                text-align: center;

                background-color: white;
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.164);

                position: -webkit-sticky;
                position: sticky;
                top: 0;

                .remove{
                    @include clear_button_style;

                    width: 24px;
                    height: 24px;

                    border-radius: 4px;

                    background-color: transparent;
                    background-image: url('../pics/icons/minus.svg');
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: 60% 60%;

                    transition: 0.3s ease;

                    &:hover{
                        background-color: $accent_red_1;
                        box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.1);
                    }
                }
            }
        }
    }
</style>